/**
 * Admin Dynamic Loader
 *
 * Provides loading state for dynamically imported admin pages.
 * Used with next/dynamic to show consistent loading UX while chunks load.
 */

export function AdminPageLoading() {
  return (
    <div className="bg-cx-bg min-h-screen pt-12 pl-14">
      <div className="p-6">
        <div className="flex items-center justify-center py-20">
          <div className="text-center">
            <div className="border-cx-border border-t-cx-accent rounded-nx-full mx-auto mb-4 h-10 w-10 animate-spin border-2" />
            <p className="text-cx-muted text-sm">Loading admin panel...</p>
          </div>
        </div>
      </div>
    </div>
  )
}
